import { Injectable } from '@angular/core';
import { VendorRemoteControlSessionResponse } from 'common/api/models/vendor-remote-control-session-response.model';
import { BcRestApi } from 'common/api/rest-api';
import { PopupWindowService } from 'shared/services/popup-window/popup-window.service';

export const VIDEO_WINDOW_TARGET = 'bold360_rc_';

@Injectable({
  providedIn: 'root'
})
export class RemoteControlService {
  constructor(private _popupWindowService: PopupWindowService, private _bcRestApi: BcRestApi) {}

  async joinRemoteControlSession(chatId: string): Promise<void> {
    const windowTarget = VIDEO_WINDOW_TARGET + chatId;
    this._popupWindowService.preparePopupFor(windowTarget);
    const { agentUrl, isNew }: VendorRemoteControlSessionResponse =
      await this._bcRestApi.joinVendorRemoteControlSession(chatId);
    if (isNew) {
      this._popupWindowService.navigateAndFocusOrOpenPopupWindow(agentUrl, windowTarget);
    } else {
      this._popupWindowService.focusOrOpenPopupWindow(agentUrl, windowTarget);
    }
  }

  async requestRemoteControlSession(chatId: string): Promise<void> {
    await this._bcRestApi.joinVendorRemoteControlSession(chatId);
  }

  async cancelRemoteControlSession(chatId: string): Promise<void> {
    await this._bcRestApi.cancelVendorRemoteControlSession(chatId);
  }
}
